import React, { Component } from 'react';
import {
  withRouter,
  Link,
} from 'react-router-dom';
import { connect } from 'react-redux';
import { formatRoute } from 'react-router-named-routes';

import {
  Avatar,
  Hidden,
  Dialog,
  List,
  ListItem,
  ListItemText,
  Divider,
  MenuItem,
  Menu,
  IconButton,
  Typography,
  Toolbar,
  AppBar,
  Button,
} from '@material-ui/core';
import DashboardOutlined from '@material-ui/icons/DashboardOutlined';
import SearchOutlined from '@material-ui/icons/SearchOutlined';
import MenuOutlined from '@material-ui/icons/MenuOutlined';
import CloseIcon from '@material-ui/icons/Close';

import DashNav from '../../dashboard/components/DashNav';
import CommonNavItems from '../components/CommonNavItems';
import CommonMobileNavItems from '../components/CommonMobileNavItems';

import * as authActions from '../../auth/actions';
import * as constants from '../../config/constants';
import * as routes from '../../config/routes';
import classes from '../../css/getCSS';

import { getLogo } from '../../util';
import { AUSTRALIA_SITE_HOST, NZFIJI_SITE_HOST } from "../../config/constants";


class AuthNavbar extends Component {
  state = {
    anchorEl: null,
    mobileMenuOpen: false,
  }

  openDropMenu = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  }

  closeDropMenu = () => {
    this.setState({ anchorEl: null });
  };

  openMobileMenu = () => {
    this.setState({
      mobileMenuOpen: true,
    });
  }

  closeMobileMenu = () => {
    this.setState({
      mobileMenuOpen: false,
    });
  }

  logout = () => {
    this.props.logout(this.props.token);
  }

  render() {
    console.log('AuthNavbar===props===',this.props)
    const logo = getLogo();

    const avatarUrl = constants.BASE_URL + this.props.user.avatar;

    const dropMenuOpen = Boolean(this.state.anchorEl);

    const dropMenu = (
      <Menu
        id="menu-appbar"
        anchorEl={this.state.anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={dropMenuOpen}
        onClose={this.closeDropMenu}
      >
        <MenuItem onClick={this.logout}>Logout</MenuItem>
      </Menu>
    );

    const navItems = (
      <React.Fragment>
        <CommonNavItems />
        <div
          role="presentation"
          className={classes.navAvatarWrapper}
          onClick={this.openDropMenu}
          onKeyPress={this.openDropMenu}
        >
          <Avatar
            alt={this.props.user.first_name}
            src={avatarUrl}
            className={classes.navAvatar}
          />
          <span className={classes.navName}>{this.props.user.first_name}</span>
          <span className="material-icons" style={{ color: '#777' }}>keyboard_arrow_down</span>
        </div>
        {dropMenu}
      </React.Fragment>
    );

    const fullName = `${this.props.user.first_name} ${this.props.user.last_name}`;

    const mobileDialog = (
      <Dialog
        fullScreen
        open={this.state.mobileMenuOpen}
        onClose={this.closeMobileMenu}
        classes={{
          paper: classes.dialogCard,
        }}
      >
        <AppBar style={{ position: 'relative' }}>
          <Toolbar>
            <Typography variant="title" color="inherit" className={classes.grow}>Menu</Typography>
            <IconButton color="inherit" onClick={this.closeMobileMenu} aria-label="Close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Link
          to={formatRoute(routes.VIEW_PROFILE, { uuid: this.props.user.slug })}
          className={classes.linkDeCSS}
        >
          <List>
            <ListItem button>
              <Avatar alt={this.props.user.first_name} src={avatarUrl} />
              <ListItemText primary={fullName} />
            </ListItem>
          </List>
        </Link>
        <Divider />
        <DashNav
          user={this.props.user}
          dashActiveLink={this.props.dashActiveLink}
          closeDialog={this.closeMobileMenu}
        />
        <Divider />
        <List>
          <ListItem button onClick={this.logout}>
            <ListItemText primary="Logout" />
          </ListItem>
        </List>
        <Divider />
        <CommonMobileNavItems displayLogin={false} />
      </Dialog>
    );

    let subMenu = (
      <ul className={classes.subMenu}>
        <li className={this.props.activeLink === 'home' ? classes.active : null}><Link to="/"><DashboardOutlined /> <span>Home</span></Link></li>
        <Hidden mdUp>
          <li>
            <IconButton
              className={classes.iconMenuButton}
              onClick={this.openMobileMenu}
            >
              <MenuOutlined />
            </IconButton>
          </li>
        </Hidden>
      </ul>
    );

    if(this.props.user.state === 1){
      subMenu = (
        <ul className={classes.subMenu}>
          <li className={this.props.activeLink === 'home' ? classes.active : null}><Link to="/"><DashboardOutlined /> <span>Home</span></Link></li>
          <li className={this.props.activeLink === 'search' ? classes.active : null}>
            <Link to={formatRoute(routes.SEARCH_FORM, { type: 'by-criteria' })}><SearchOutlined /> <span>Search</span></Link>
          </li>
          <Hidden mdUp>
            <li>
              <IconButton
                className={classes.iconMenuButton}
                onClick={this.openMobileMenu}
              >
                <MenuOutlined />
              </IconButton>
            </li>
          </Hidden>
        </ul>
      );
    }

    let subMenuAppBar = null;

    if (!this.props.onlyLogout) {
      subMenuAppBar = (
        <AppBar position="static" color="primary" elevation={0} className={[classes.AuthNavbar, classes.subAppBar].join(' ')}>
          <Toolbar className={classes.subMenuToolbar}>
            <Link to="/" className={classes.linkDeCSS}>
              <div>
                <img src={logo} alt="lmp_1" className={[classes.navLogo, classes.subNavLogo].join(' ')} />
                <Hidden mdUp>
                  <span className={classes.stateName}>
                    {(window.location.host === constants.SAURASHTRA1_SITE_HOST) && <span>Saurashtra1 Bureau</span>}
                    {(window.location.host === constants.SAURASHTRA2_SITE_HOST) && <span>Saurashtra2 Bureau</span>}
                    {(window.location.host === constants.SAURASHTRA3_SITE_HOST) && <span>Saurashtra3 Bureau</span>}
                    {(window.location.host === constants.SAURASHTRA4_SITE_HOST) && <span>Saurashtra4 Bureau</span>}
                    {(window.location.host === constants.KUTCH_HOST) && <span>Kutch Bureau</span>}
                    {(window.location.host === constants.MUMBAI_SITE_HOST) && <span>Mumbai Bureau</span>}
                    {(window.location.host === constants.MAHARASHTRA_SITE_HOST) && <span>Maharastra Bureau</span>}
                    {(window.location.host === constants.EASTINDIA_SITE_HOST)  && <span>East India Bureau</span>}
                    {(window.location.host === constants.NORTHINDIA_SITE_HOST) && <span>North India Bureau</span>}
                    {(window.location.host === constants.NORTHGUJARAT_SITE_HOST) && <span>North Gujarat Bureau</span>}
                    {(window.location.host === constants.SOUTHGUJARAT_SITE_HOST) && <span>South Gujarat Bureau</span>}
                    {(window.location.host === constants.SOUTHINDIA_SITE_HOST) && <span>South India Bureau</span>}
                    {(window.location.host === constants.CENTRALGUJARAT1_SITE_HOST) && <span>Central Gujarat1 Bureau</span>}
                    {(window.location.host === constants.CENTRALGUJARAT2_SITE_HOST) && <span>Central Gujarat2 Bureau</span>}
                    {(window.location.host === constants.VIDARBHA_SITE_HOST) && <span>Vidarbha Bureau</span>}
                    {(window.location.host === constants.CENTRAL_INDIA_SITE_HOST) && <span>Central India Bureau</span>}
                    {(window.location.host === constants.EUROPE_SITE_HOST) && <span>Europe Bureau</span>}
                    {(window.location.host === constants.MIDDLE_EAST_SITE_HOST) && <span>Middle East Bureau</span>}
                    {(window.location.host === constants.USA_SITE_HOST) && <span>USA Bureau</span>}
                    {(window.location.host === constants.AFRICA_SITE_HOST) && <span>Africa Bureau</span>}
                    {(window.location.host === constants.TANZANIA_SITE_HOST) && <span>Tanzania Bureau</span>}
                    {(window.location.host === constants.CANADA_SITE_HOST) && <span>Canada Bureau</span>}
                    {(window.location.host === constants.KENYA_SITE_HOST) && <span>Kenya Bureau</span>}
                    {(window.location.host === constants.UGANDA_SITE_HOST) && <span>Uganda Bureau</span>}
                    {(window.location.host === constants.AUSTRALIA_SITE_HOST) && <span>Australia Bureau</span>}
                    {(window.location.host === constants.NZFIJI_SITE_HOST) && <span>New Zealand and Fiji Bureau</span>}
                  </span>
                </Hidden>
              </div>
            </Link>
            {subMenu}
          </Toolbar>
        </AppBar>
      );
    } else {
      subMenuAppBar = (
        <Hidden mdUp>
          <AppBar position="static" color="primary" elevation={0} className={[classes.AuthNavbar, classes.subAppBar].join(' ')}>
            <Toolbar className={classes.subMenuToolbar}>
              <Link to="/" className={classes.linkDeCSS}>
                <img src={logo} alt="lmp_2" className={[classes.navLogo, classes.subNavLogo].join(' ')} />
              </Link>
              <Button
                onClick={this.logout}
                style={{ color: '#fff' }}
              >
                Logout
              </Button>
            </Toolbar>
          </AppBar>
        </Hidden>
      );
    }

    const navbarWrapperStyle = {
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: 1000,
    };

    const navbar = (
      <div style={navbarWrapperStyle}>
        <AppBar position="static" color="primary" elevation={0} className={[classes.AuthNavbar, classes.hiddenSM, classes.hiddenXS].join(' ')}>
          <Toolbar>
            <Typography variant="title" color="inherit" className={classes.grow}>
              <Link to="/" className={classes.linkDeCSS}>
                <div>
                  <img src={logo} alt="lmp_3" className={classes.navLogo} />
                  <span className={classes.stateName}>
                    {(window.location.host === constants.SAURASHTRA1_SITE_HOST) && <span>Saurashtra1 Bureau</span>}
                    {(window.location.host === constants.SAURASHTRA2_SITE_HOST) && <span>Saurashtra2 Bureau</span>}
                    {(window.location.host === constants.SAURASHTRA3_SITE_HOST) && <span>Saurashtra3 Bureau</span>}
                    {(window.location.host === constants.SAURASHTRA4_SITE_HOST) && <span>Saurashtra4 Bureau</span>}
                    {(window.location.host === constants.KUTCH_HOST) && <span>Kutch Bureau</span>}
                    {(window.location.host === constants.MUMBAI_SITE_HOST) && <span>Mumbai Bureau</span>}
                    {(window.location.host === constants.MAHARASHTRA_SITE_HOST) && <span>Maharastra Bureau</span>}
                    {(window.location.host === constants.EASTINDIA_SITE_HOST)  && <span>East India Bureau</span>}
                    {(window.location.host === constants.NORTHINDIA_SITE_HOST) && <span>North India Bureau</span>}
                    {(window.location.host === constants.NORTHGUJARAT_SITE_HOST) && <span>North Gujarat Bureau</span>}
                    {(window.location.host === constants.SOUTHGUJARAT_SITE_HOST) && <span>South Gujarat Bureau</span>}
                    {(window.location.host === constants.SOUTHINDIA_SITE_HOST) && <span>South India Bureau</span>}
                    {(window.location.host === constants.CENTRALGUJARAT1_SITE_HOST) && <span>Central Gujarat1 Bureau</span>}
                    {(window.location.host === constants.CENTRALGUJARAT2_SITE_HOST) && <span>Central Gujarat2 Bureau</span>}
                    {(window.location.host === constants.VIDARBHA_SITE_HOST) && <span>Vidarbha Bureau</span>}
                    {(window.location.host === constants.CENTRAL_INDIA_SITE_HOST) && <span>Central India Bureau</span>}
                    {(window.location.host === constants.EUROPE_SITE_HOST) && <span>Europe Bureau</span>}
                    {(window.location.host === constants.MIDDLE_EAST_SITE_HOST) && <span>Middle East Bureau</span>}
                    {(window.location.host === constants.USA_SITE_HOST) && <span>USA Bureau</span>}
                    {(window.location.host === constants.AFRICA_SITE_HOST) && <span>Africa Bureau</span>}
                    {(window.location.host === constants.TANZANIA_SITE_HOST) && <span>Tanzania Bureau</span>}
                    {(window.location.host === constants.CANADA_SITE_HOST) && <span>Canada Bureau</span>}
                    {(window.location.host === constants.KENYA_SITE_HOST) && <span>Kenya Bureau</span>}
                    {(window.location.host === constants.UGANDA_SITE_HOST) && <span>Uganda Bureau</span>}
                    {(window.location.host === constants.AUSTRALIA_SITE_HOST) && <span>Australia Bureau</span>}
                    {(window.location.host === constants.NZFIJI_SITE_HOST) && <span>New Zealand and Fiji Bureau</span>}
                  </span>
                </div>
              </Link>
            </Typography>
            {navItems}
          </Toolbar>
        </AppBar>
        {subMenuAppBar}
        {mobileDialog}
      </div>
    );

    return navbar;
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    user: state.auth.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: token => dispatch(authActions.logout(token)),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthNavbar));



// WEBPACK FOOTER //
// ./src/common/containers/AuthNavbar.js